import React from "react";
// components
import Banner from "./components/Banner";
import Header from "./components/Header";
import Nav from "./components/Nav";
import About from "./components/About";
import Services from "./components/Services";
import Work from "./components/Work";
import Reviews from "./components/Reviews";
import Contact from "./components/Contact";
import { toast, ToastContainer } from "react-toastify";

const App = () => {
  return (
    <div className="bg-site bg-no-repeat bg-cover overflow-hidden">
      <Header />
      <Banner />
      <Nav />
      <About />
      <Services />
      <Work />
      <Reviews />
      {/* Add ToastContainer here */}
      <ToastContainer />
      <Contact />
      {/* ... rest of your components ... */}
    </div>
  );
};

export default App;
